import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPhone = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "inherit",
		fillRule: "evenodd",
		d: "M17 3.75c1.85 0 3.18 1.48 2.83 3.05A17.27 17.27 0 0 1 6.8 19.83c-1.57.35-3.05-.97-3.05-2.83v-1.75c0-.12.11-.28.32-.3a11.94 11.94 0 0 0 2.85-.6l1.37 1.37a.75.75 0 0 0 .85.14 14.3 14.3 0 0 0 6.72-6.72.75.75 0 0 0-.15-.85l-1.37-1.37c.32-.9.53-1.86.61-2.85.02-.2.18-.32.3-.32H17zm4.3 3.38c.61-2.74-1.74-4.88-4.3-4.88h-1.75c-.98 0-1.71.79-1.79 1.68a10.43 10.43 0 0 1-.68 2.9.75.75 0 0 0 .17.81l1.32 1.33a12.81 12.81 0 0 1-5.3 5.3l-1.33-1.32a.75.75 0 0 0-.8-.17c-.91.36-1.89.59-2.9.68-.9.08-1.69.8-1.69 1.79V17c0 2.56 2.14 4.91 4.88 4.3A18.77 18.77 0 0 0 21.3 7.12z",
		clipRule: "evenodd"
	})
});
export default SvgPhone;
